"use client";

import React from "react";
import { ArrowRight, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyForAFreshLook() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: btnRef,
    isVisible: isBtnVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="242714" id="build-meaningful-work-with-riverbend" className="relative overflow-hidden bg-primary-900 text-white py-20 md:py-28">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1624643/img/organized_workspace_financial.png')] bg-cover bg-center opacity-30" aria-hidden="true" />

        <div className="absolute inset-0 bg-primary-900/85" />

        <div className="absolute inset-0 bg-gradient-to-br from-primary-900 via-primary-900/90 to-secondary-900/80" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div ref={textRef} className={`max-w-4xl mx-auto text-center transition-all duration-1000 transform ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="h-1 w-12 bg-secondary-400 mx-auto mb-6 rounded-full" />

          <p className="text-secondary-300 font-semibold tracking-[0.18em] text-xs uppercase mb-4 font-default">
            Careers at RiverBend
          </p>

          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white tracking-tight leading-tight">
            Build meaningful work with RiverBend.
          </h2>

          <p className="font-default text-lg md:text-xl text-white/85 max-w-3xl mx-auto font-medium leading-relaxed">
            If you value practical work, clear communication, respectful client
            support, and the chance to help organizations build stronger
            systems, we would be glad to hear from you.
          </p>
        </div>

        <div ref={btnRef} className={`flex flex-col sm:flex-row justify-center gap-3 mt-10 transition-all duration-1000 delay-200 transform ${isBtnVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild size="lg" className="group bg-secondary-500 hover:bg-secondary-600 text-secondary-foreground text-base md:text-lg px-8 py-6 rounded-md font-semibold shadow-lg">
            <Link to="/ContactPage">
              <Mail className="mr-2 w-5 h-5" />
              Contact Us About Opportunities
              <ArrowRight className="ml-2 w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>

          <Button asChild size="lg" variant="outline" className="border-white/30 bg-white/10 hover:bg-white/15 text-white text-base md:text-lg px-8 py-6 rounded-md font-semibold backdrop-blur-sm">
            <Link to="/TeamAndCareersPage">View Career Opportunities</Link>
          </Button>
        </div>
      </div>
    </section>;
}